import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import { useMedia } from 'react-use'

import { DESKTOP_VIEW, MOBILE_VIEW } from 'utils/view'

import { BasketComprehensionBanner } from './BasketComprehensionBanner'

import css from './BoxSummaryBanner.css'

export const BoxSummaryBanner = () => {
  const isToMedium = useMedia(css.BreakpointToMedium)
  const view = isToMedium ? MOBILE_VIEW : DESKTOP_VIEW

  return (
    <>
      <Box height={['146px', '88px', '88px']} />
      <BasketComprehensionBanner view={view} />
    </>
  )
}
